import type {UserResponseBody} from '@dms/api/shared';

import type {Nullish} from 'shared/web';

/**
 * System users are provisioned by the platform, not by a tenant. The API rejects
 * any modification of them with 403 DMS-CO-US-0013, so the UI renders them
 * read-only instead of letting the user submit a request that cannot succeed.
 */
export const isSystemUser = (user: Pick<UserResponseBody, 'type'> | Nullish): boolean =>
  user?.type === 'system';
